import { Button, Stack } from '@vapor/material'
import { useCallback, useState } from 'react'
import { SubmitHandler } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import useBreakpoints from 'src/app/hooks/breakpoints/use-breakpoints'
import { useTenant } from 'src/app/hooks/context/context.hook'
import useErrorSnackBar from 'src/app/hooks/error-snack-bar/error-snack-bar'
import { ChargeCategoryFragment, ProductFragment, State, useCreateProductMutation } from 'src/api/api.generated'
import { ProductSchema } from './add-new-product/add-new-product.hook'
import AddNewProductForm from './add-new-product/add-new-product.form'

// const schema = z.object({
//   chargeCategoryId: z.string().min(1).default(''),
//   chargeCategory: z.object({
//     name: z.string(),
//     defaultVatId: z.string(),
//     defaultVat: z.object({
//       value: z.number(),
//       code: z.string(),
//     }),
//   }),
//   description: z.string().min(1),
//   amount: z.number(),
//   isActive: z.boolean().default(true),
// })

// type Product = z.TypeOf<typeof schema>

export type ProductProps = {
  currentSelectedChargeCategory?: ChargeCategoryFragment
  propertyId: string
  loading: boolean
  onProductCreatedWithSuccess: (product: ProductSchema) => void
  checkin: Date | null
  checkout: Date | null
}

export default function PosNewProduct(props: ProductProps) {
  const { loading, propertyId, currentSelectedChargeCategory, onProductCreatedWithSuccess, checkin, checkout } = props
  const { t } = useTranslation()
  const { id: tenantId } = useTenant()
  const [createProductMutation] = useCreateProductMutation()
  const showErrorSnackBar = useErrorSnackBar()

  // const [loading, setLoading] = useState(false)

  // useEffect(() => {
  //   setLoading(fatherLoading)
  // }, [fatherLoading])

  // const [chargeCategoryVat, setChargeCategoryVat] = useState<string | undefined>()
  const [showDialog, setShowDialog] = useState(false)

  // const customErrorMap = useCustomError()
  // z.setErrorMap(customErrorMap)

  // const {
  //   control,
  //   handleSubmit,
  //   formState: { errors },
  //   reset,
  //   setValue,
  // } = useForm<Product>({ resolver: zodResolver(schema) })

  // const setDefaultValue = (currentSelectedChargeCategory: ChargeCategoryFragment | undefined) => {
  //   setValue('chargeCategoryId', currentSelectedChargeCategory?.id ?? '')
  //   setChargeCategoryVat(currentSelectedChargeCategory?.defaultVat.code)

  //   if (currentSelectedChargeCategory) {
  //     setValue('chargeCategory.defaultVat.value', currentSelectedChargeCategory.defaultVat.value)
  //     setValue('chargeCategory.name', currentSelectedChargeCategory.name)
  //     setValue('chargeCategory.defaultVatId', currentSelectedChargeCategory.defaultVatId)
  //     setValue('chargeCategory.defaultVat.code', currentSelectedChargeCategory.defaultVat.code)
  //   }
  // }

  // useEffect(() => {
  //   setDefaultValue(currentSelectedChargeCategory)
  // }, [currentSelectedChargeCategory])

  const onSubmit: SubmitHandler<ProductSchema> = useCallback(
    async (data: ProductSchema) => {
      // reset()
      // setDefaultValue(currentSelectedChargeCategory)
      onProductCreatedWithSuccess(data)
      setShowDialog(false)
    },
    [createProductMutation, showErrorSnackBar, propertyId, tenantId, currentSelectedChargeCategory],
  )

  const handleCloseDialog = useCallback(() => {
    setShowDialog(false)
    // reset()
    // setDefaultValue(currentSelectedChargeCategory)
  }, [currentSelectedChargeCategory])

  const { sm } = useBreakpoints()

  return (
    <Stack direction="row" justifyContent={sm ? 'flex-end' : 'center'} pb="15px" pt="15px">
      <Button size="small" variant="outlined" onClick={() => setShowDialog(!showDialog)} disabled={loading}>
        {t('pms.booking.pos.product-creation.show-button-title')}
      </Button>

      {showDialog && (
        <AddNewProductForm
          appearance={{
            type: 'DIALOG',
            open: showDialog,
            onClose: handleCloseDialog,
          }}
          onCancel={handleCloseDialog}
          onSubmit={onSubmit}
          currentSelectedChargeCategory={currentSelectedChargeCategory}
          loading={loading}
          propertyId={propertyId}
          checkin={checkin}
          checkout={checkout}
        />
      )}
      {/* <FormLayout //
        title={t('pms.settings.product.form.title')}
        appearance={{ type: 'DIALOG', open: showDialog, onClose: handleCloseDialog }}
        toolbar={
          <FormLayoutDefaultToolbar //
            saveButton={{
              clickHandler: handleSubmit(onSubmit),
              text: t('pms.booking.pos.product-creation.create-product-title'),
            }}
            cancelButton={{
              clickHandler: handleCloseDialog,
            }}
          />
        }
      >
        <Stack direction={'column'} spacing={1}>
          <Controller<Product, 'chargeCategoryId'>
            name={'chargeCategoryId'}
            control={control}
            render={({ field: { value, onChange } }) => (
              <FormItem fullWidth fieldLabel={t('pms.settings.product.form.charge_category')} errorMessage={errors.chargeCategoryId?.message} sx={{ minWidth: 200 }}>
                <ChargeCategoriesSingleSelect
                  value={value}
                  onChange={onChange}
                  onChangeChargeCategory={(value) => {
                    setChargeCategoryVat(value?.defaultVat.code)
                    if (value) {
                      setValue('chargeCategory.defaultVat.value', value.defaultVat.value)
                      setValue('chargeCategory.defaultVat.code', value.defaultVat.code)
                      setValue('chargeCategory.name', value.name)
                      setValue('chargeCategory.defaultVatId', value.defaultVatId)
                    }
                  }}
                  error={errors.chargeCategoryId?.message}
                  disabled={loading}
                  propertyId={propertyId}
                />
              </FormItem>
            )}
          />
          <Controller<Product, 'description'>
            name={'description'}
            control={control}
            defaultValue={''}
            render={({ field: { value, onChange } }) => (
              <FormItem fullWidth fieldLabel={t('pms.settings.product.form.description')} errorMessage={errors.description?.message} sx={{ minWidth: 200 }}>
                <TextField disabled={loading} value={value} onChange={onChange} />
              </FormItem>
            )}
          />

          <Controller<Product, 'amount'>
            name={'amount'}
            control={control}
            render={({ field: { value, onChange } }) => (
              <FormItem fullWidth fieldLabel={t('pms.settings.product.form.price')} errorMessage={errors.amount?.message}>
                <HicAmountField disabled={loading} currency={currency} value={value} onChange={onChange} />
              </FormItem>
            )}
          />

          <FormItem fullWidth fieldLabel={t('pms.settings.product.form.vat')}>
            <TextField value={chargeCategoryVat ? chargeCategoryVat : ''} disabled={true} />
          </FormItem>
        </Stack>
      </FormLayout> */}
    </Stack>
  )
}
